<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="12" class="d-md-flex">
        <RangeFilter 
          :end="dateEnd" 
          :start="dateStart" 
          @getDates="getDates" 
          :excludePeriod="excludePeriod"
          :defaultPeriod="defaultPeriod"
          :setDates="true"
          :disabled="loaded"
        />
        <v-switch
          v-model="isCompareFilter"
          hide-details
          color="orange darken-3"
          class="mx-5 mt-md-1 my-3 mb-md-0"
        >
          <template #label>
            <span class="ml-1">Compare</span>
          </template>
        </v-switch>
        <CompareFilter
          v-if="isCompareFilter"
          :end="dateCompareEnd"
          :start="dateCompareStart"
          :periodStart="dateStart"
          :periodEnd="dateEnd"
          @getDates="getCompareDates"
          :bgColor="compareFilterColor"
          :filterIcon="compareIcon"
          :diffDays="diffDays"
          :disabled="loadedCompare"
        />
      </v-col>
    </v-row>
    <v-row cols="12">
      <v-col>
        <h2>Orders by gallons</h2>
        <v-progress-linear
          indeterminate
          color="indigo"
          v-if="loaded"
        ></v-progress-linear>
        <highcharts :options="ordersByGallons" :updateArgs="updateArgs"></highcharts>
      </v-col>
    </v-row>
    <v-row cols="12">
      <v-col>
        <h2>Orders by gallons %</h2>
        <v-progress-linear
          indeterminate
          color="indigo"
          v-if="loaded"
        ></v-progress-linear>
        <highcharts :options="ordersPCT" :updateArgs="updateArgs"></highcharts>
      </v-col>
    </v-row>
    <v-row cols="12">
      <v-col>
        <h2>Total gallon by date</h2>
        <v-progress-linear
          indeterminate
          color="indigo"
          v-if="loaded"
        ></v-progress-linear>
        <highcharts :options="gallonsByDate"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import moment from 'moment'
import RangeFilter from '@/components/filters/RangePicker'
import CompareFilter from '@/components/filters/ComparePicker'
import {Chart} from 'highcharts-vue'

export default {
  components: {
    RangeFilter,
    CompareFilter,
    highcharts: Chart
  },
  data() {
    return {
      hideAnything: false,
      selected: [],
      data: {
        gallons_by_date: {},
        gallons_distribution: [],
      },
      dataCompare: {
        gallons_by_date: {},
        gallons_distribution: [],
      },
      historyChanged: [],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
                    Date.UTC(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1)).toISOString().substr(0, 10),
      dateCompareEnd: new Date(
                        Date.UTC(
                            new Date().getFullYear(),
                            new Date().getMonth(),
                            0
                            )).toISOString().substr(0, 10),
      dateCompareStart: new Date(
                          Date.UTC(
                              new Date().getFullYear(),
                              new Date().getMonth()-1,
                              0
                              )).toISOString().substr(0, 10), 
      diffDays: 0,
      compareFilterColor: 'orange darken-3',
      compareIcon: 'mdi-compare-vertical',
      isCompareFilter: false,
      excludePeriod: [],
      defaultPeriod: 4,
      loaded: false,
      loadedCompare: false,
      ordersByGallons: {
        chart: {
          height: 500,
          type: 'column',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = `${this.series.name}<br/>`
                tip += `${this.x} gallons: <b>${this.y} orders</b>`
                return tip
            },
        },
        xAxis: {
          categories: [],
          gridLineWidth: 1,
          crosshair: true,
          labels: {
            formatter: function() {
                return this.value
            }
          },
          type: '',
          title: {
            text: 'Gallon Groups'
          }
        },
        yAxis: {
          title: {
            text: 'Orders'
          },
          labels: {
            formatter: function() {
                return this.value;
            }
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [],
      },
      gallonsByDate: {
        chart: {
          height: 500,
          type: 'column',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = `<b>${this.x}</b><br/>`
                tip += `<br/><span>${this.series.name}</span>: ${this.y}<br/>`
                return tip
            },
        },
        xAxis: {
          categories: [],
          crosshair: true,
          gridLineWidth: 1,
          labels: {
            formatter: function() {
                return this.value
            }
          },
          type: '',
          title: {
            text: 'Dates'
          }
        },
        yAxis: {
          title: {
            text: 'Gallons'
          },
          labels: {
            formatter: function() {
                return this.value;
            }
          },
          gridLineWidth: 1,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [],
      },
      updateArgs: [true, true, true],
      ordersPCT: {
        chart: {
          type: 'bar',
          zoomType: 'y'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          reversed: true
        },
        tooltip: {
            formatter: function () {
                var tip = `${this.x}<br/>`
                tip += `<span>${this.series.name} gallons</span>: <b>${this.y.toFixed(2)}%</b>`
                return tip
            },
        },
        xAxis: {
          categories: [],
          crosshair: true,
          gridLineWidth: 1,
          labels: {
            formatter: function() {
                return this.value
            },
            x: 150,
            y: -20
          },
          type: '',
          title: {
            text: ''
          }
        },
        yAxis: {
          max: 100,
          title: {
            text: ''
          },
          labels: {
            formatter: function() {
                return `${this.value}%`;
            }
          },
          gridLineWidth: 1,
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            pointWidth: 20
          }
        },
        series: []        
      },
      colors: [
        '#ECD3FF', '#F988D9', '#EA6565', '#FF9D9D', '#FBC17D', '#FDED9C', '#43A357',
        '#2AC0AC', '#D5E7B1', '#A1E296', '#B9E7F5', '#398BD8', '#96BCF3', '#8166D0',
        '#9C4B9D', '#B386C5', '#ECD3FF', '#F988D9', '#F86499', '#C264F8'
      ]
    }
  },
  created(){
    this.countDiffDayes()
    this.countDateCompareEnd()
    this.countDateCompareStart()
  },
  watch: {
    isCompareFilter(){
      if (this.isCompareFilter){
        this.applayCompares()    
      } else {
        let d = moment(this.dateStart)
        this.dateCompareEnd = new Date(Date.UTC(
                                  new Date(d).getFullYear(),
                                  new Date(d).getMonth(),
                                  new Date(d).getDate() - 1)
                                ).toISOString().substr(0, 10)

        this.dateCompareStart = new Date(
                                  Date.UTC(
                                    new Date(d).getFullYear(),
                                    new Date(d).getMonth(),
                                    new Date(d).getDate() - this.diffDays)
                                  ).toISOString().substr(0, 10)

        this.ordersByGallons.series.pop()
        this.ordersPCT.series.map(e => e.data.pop())
      }
    },
    dateStart(){
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()        
    },
    dateEnd(){
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()        
    }
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    if (localStorage.getItem('fromCounterPage')) {
      let data = JSON.parse(localStorage.getItem('fromCounterPage'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('fromCounterPage')
    }

    this.loaded = true
    axios
        .get('/username')
        .then(response => (this.userName = response.data))
        
    this.applyFilters()
  },
  methods: {
    getDates({ dateStart, dateEnd, compareMode }){
      this.dateStart = dateStart
      this.dateEnd = dateEnd
      this.isCompareFilter = compareMode
      this.applyFilters()
    },
    getCompareDates({ dateStart, dateEnd }){
      this.dateCompareStart = dateStart
      this.dateCompareEnd = dateEnd
      this.applayCompares()
    },
    countDiffDayes(){
      const oneDay = 24 * 60 * 60 * 1000
      const firstDate = new Date(this.dateStart)
      const secondDate = new Date(this.dateEnd)

      this.diffDays =  Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1
    },
    countDateCompareEnd(){
      let d = moment(this.dateStart)

      this.dateCompareEnd = new Date(
                              Date.UTC(
                                new Date(d).getFullYear(),
                                new Date(d).getMonth(),
                                new Date(d).getDate() - 1)
                              ).toISOString().substr(0, 10)
    },
    countDateCompareStart(){
      let d = moment(this.dateStart)

      this.dateCompareStart = new Date(
                              Date.UTC(
                                new Date(d).getFullYear(),
                                new Date(d).getMonth(),
                                new Date(d).getDate() - this.diffDays)
                              ).toISOString().substr(0, 10)
    },
    applyFilters() {
      this.loaded = true
      axios
          .get(`/dashboard/gallons/${this.dateStart}/${this.dateEnd}`)
          .then(response => {
            this.data = response.data

            this.gallonsByDate.series.splice(0, 1, {
              name: this.data.gallons_by_date.datasets[0].label,
              data: this.data.gallons_by_date.datasets[0].data,
              color: '#6372c3'
            })
            this.gallonsByDate.xAxis.categories = this.data.gallons_by_date.labels

            this.ordersByGallons.series.splice(0, 1, {
              name: `from ${this.dateStart} to ${this.dateEnd}`,
              data: this.data.gallons_distribution.map(e => e.orders_cnt),
              color: '#6372c3'
            })
            this.ordersByGallons.xAxis.categories = this.data.gallons_distribution.map(e => e.label)
            
            this.data.gallons_distribution.map((e, i) => {
              this.ordersPCT.series.splice(i, 1, {
                name: e.label,
                data: [e.orders_pct],
                color: this.colors[i]
              })
            })
            this.ordersPCT.xAxis.categories.splice(0, 1, `${this.dateStart}~${this.dateEnd}`)

            this.loaded = false
          })
    },
    applayCompares() {
      this.loadedCompare = true
        axios
          .get(`/dashboard/gallons/${this.dateCompareStart}/${this.dateCompareEnd}`)
          .then(response => {
            this.dataCompare = response.data

            this.ordersByGallons.series.splice(1, 1, {
                name: `from ${this.dateCompareStart} to ${this.dateCompareEnd}`,
                data: this.dataCompare.gallons_distribution.map(e => e.orders_cnt),
                color: '#f79e20'
              })
               
            this.dataCompare.gallons_distribution.map(e => {
              this.ordersPCT.series.find(i => i.name == e.label).data.splice(1, 1, e.orders_pct)
            })
            this.ordersPCT.xAxis.categories.splice(1, 1, `${this.dateCompareStart}~${this.dateCompareEnd}`)

            this.loadedCompare = false
          })          
    }
  }
}
</script>

<style scoped>
  .text-card{
    font-size: 30px;
    text-align: center;
  }
</style>